import { Component, Input, EventEmitter, Output, ViewChildren, ElementRef, QueryList, OnChanges, SimpleChanges } from '@angular/core';
import { FamiliaResponse, GrupoIntegracaoViewModel } from 'src/app/shared/models/produto.model';

@Component({
    selector: 'app-grid-grupos',
    templateUrl: './grid-grupos.component.html',
    styleUrls: ['./grid-grupos.component.scss'],
})
export class GridGruposComponent {
    @ViewChildren('inpAcrescimoReaisGrupo') inpAcrescimoReaisGrupo!: QueryList<ElementRef>;
    @ViewChildren('inpAcrescimoPorcentoGrupo') inpAcrescimoPorcentoGrupo!: QueryList<ElementRef>;

    @Input() grupos: GrupoIntegracaoViewModel[] = [];
    @Input() indexItemSelecionado: number = -1;
    @Input() plataformaSelecionada: number = 0;
    @Output() alterarIndexItemSelecionado = new EventEmitter<number>();
    @Output() alterarPropriedade = new EventEmitter<GrupoIntegracaoViewModel>();
    @Output() alterarStatus = new EventEmitter<GrupoIntegracaoViewModel>();
    @Output() abrirPerguntasGrupo = new EventEmitter<GrupoIntegracaoViewModel>();
    @Output() abrirAdicionaisGrupo = new EventEmitter<GrupoIntegracaoViewModel>();

    public readonly coresPorIntegracao: Record<string, string> = {
        'IFOOD': '#FF3C3C',
        'QUERO DELIVERY': '#6C3995',
        'CARDAPIO ONLINE': '#2FAC58',
    };


    public focoInputAcrescimo(event: Event, campo: 'acrescimoPorcento' | 'acrescimoReais', index: number) {
        event.preventDefault();

        switch (campo) {
            case 'acrescimoPorcento':
                setTimeout(() => this.inpAcrescimoReaisGrupo.toArray()[index].nativeElement.focus());
                break;
            case 'acrescimoReais':
                if (index < this.grupos.length - 1) setTimeout(() => this.inpAcrescimoPorcentoGrupo.toArray()[index + 1].nativeElement.focus());
                else setTimeout(() => this.inpAcrescimoPorcentoGrupo.toArray()[0].nativeElement.focus());
            //     break;
            // case 'precoFinal':
            //     if (index < this.produtos.length - 1) setTimeout(() => this.acrescimoPorcentoInputs.toArray()[index + 1].nativeElement.focus());
            //     else setTimeout(() => this.acrescimoPorcentoInputs.toArray()[0].nativeElement.focus());

            //     const produto = this.produtos[index];
            //     this.alterarStatusProduto(produto);
            //     this.alterarItemSelecionado(index + 1);
        }
    }


    // public focarProximoInput(indexAtual: number) {
    //     let inputsArray = this.inpAcrescimoReaisGrupo.toArray();
    //     const proximoIndex = indexAtual + 1;

    //     if (proximoIndex < this.inpAcrescimoReaisGrupo.length) {
    //         inputsArray[proximoIndex].nativeElement.focus();
    //     } else {
    //         this.alterarItemSelecionado(this.indexItemSelecionado + 1);

    //         setTimeout(() => {
    //             inputsArray = this.inpAcrescimoReaisGrupo.toArray();
    //             inputsArray[0].nativeElement.focus();
    //         });
    //     }

    //     // setTimeout(() => this.inpAcrescimoReaisGrupo.toArray()[index + 1].nativeElement.focus());

    //     // const grupo = this.grupos[index];
    //     // this.alterarStatusGrupo(grupo);
    //     // this.alterarItemSelecionado(index + 1);


    //     // if (proximoIndex < this.inputs.length) {
    //     //   (rowIndex - 1)
    //     //   inputsArray[proximoIndex].nativeElement.focus();
    //     // } else {
    //     //   this.alterarItemSelecionado(this.indexItemSelecionado + 1);

    //     //   setTimeout(() => {
    //     //     inputsArray = this.inputs.toArray();
    //     //     inputsArray[0].nativeElement.focus();
    //     //   });
    //     // }
    // }

    public alterarAcrescimoReais(grupo: GrupoIntegracaoViewModel) {
        if (grupo.acrescimoReais > 0) {
            grupo.acrescimoPorcento = 0;
            this.alterarPropriedadeGrupo(grupo);
        }
    }

    public alterarAcrescimoPorcento(grupo: GrupoIntegracaoViewModel) {
        if (grupo.acrescimoPorcento) {
            grupo.acrescimoReais = 0;
            this.alterarPropriedadeGrupo(grupo);
        }
    }

    public alterarPropriedadeGrupo(grupo: GrupoIntegracaoViewModel) {
        this.alterarPropriedade.emit(grupo);
    }

    public alterarStatusGrupo(grupo: GrupoIntegracaoViewModel) {
        this.alterarStatus.emit(grupo);
    }

    public alterarItemSelecionado(index: number) {
        this.alterarIndexItemSelecionado.emit(index);
    }

    public abrirPerguntas(grupo: GrupoIntegracaoViewModel) {
        this.abrirPerguntasGrupo.emit(grupo);
    }

    public abrirAdicionais(grupo: GrupoIntegracaoViewModel) {
        this.abrirAdicionaisGrupo.emit(grupo);
    }
}
